import { ChangeEvent, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'

import { KTSVG } from '../../../../_metronic/helpers/components/KTSVG'
import {
  AddTagsToCompanyMutation,
  AddTagsToCompanyMutationVariables,
  CompanyTypes,
  useAddTagsToCompanyMutation,
  useGetAllTransactionsQuery,
  useGetCompanyWiseDataQuery,
} from '../../../../generated/graphql'
import { graphqlRequestClient, queryClient } from '../../../../queries/client'
import Toast, { ToastType } from '../../../../utils/toast'
import { selectCustomStyles } from '../../../../utils/Select'

type Props = {
  companyType: CompanyTypes
  isIndirect: boolean
  companyId: bigint
  hissaCompanyId: string
  companyName: string
  cin?: string
  investorId?: bigint
  tags?: string[]
  showModal: boolean
  setShow: Function
  currency: string
  currentSharePrice: number
  jurisdiction: string
}
type SelectOptionType = { label?: string; value?: string }

export default function ManageCompanyTags(props: Props) {
  const tagsObjList: { value?: string; label?: string }[] = []
  const tagsList = props.tags
  tagsList?.map((tag: string) => {
    tagsObjList.push({ value: tag, label: tag })
  })
  const [values, setValues] = useState<any>(tagsObjList)
  const [inputText, setInputText] = useState<string>('')
  const [customTag, setCustomTag] = useState<boolean>(false)
  const [disable, setDisable] = useState<boolean>(false)
  const [isEqual, setIsEqual] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [removeBadge, setRemoveBadge] = useState<string>('')

  const [badgeList, setBadgeList] = useState<SelectOptionType[]>([
    { value: 'Add New', label: 'Add New' },
    { value: 'Fin-tech', label: 'Fin-tech' },
    { value: 'Green Energy', label: 'Green Energy' },
    { value: 'Information Technology', label: 'Information Technology' },
  ])

  const handleChange = (e: any) => {
    setValues(e)

    e?.map((ele: any) => {
      if (ele.value === 'Add New') {
        setValues((values: any) => {
          return values?.filter((element: any) => element?.value !== 'Add New')
        })
        setCustomTag((customTag) => {
          return !customTag
        })
      }
    })
  }
  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    setInputText(e.target.value)
    if (e.target.value && e.target.value.length > 0) {
      values.map((badge: any) => {
        if (badge.value === e.target.value) {
          setDisable(true)
          setErrorMessage('Multiple tags with the same name are not allowed ')
          setIsEqual(true)
        } else {
          setDisable(false)
          setErrorMessage('')
          setIsEqual(false)
        }
      })
    }
  }

  const compKey = {
    input: {
      type: props.companyType,
      hissaCompanyId: props.hissaCompanyId || '',
      id: Number(props.companyId) || 0,
    },
  }

  const getAllTransactionQuery = useGetAllTransactionsQuery.getKey()
  const getCompanyWiseQuery = useGetCompanyWiseDataQuery.getKey(compKey)

  const mutateAddTagsToCompany = useAddTagsToCompanyMutation<Error>(
    graphqlRequestClient,
    {
      onSuccess: (
        data: AddTagsToCompanyMutation,
        _variables: AddTagsToCompanyMutationVariables,
        _context: unknown
      ) => {
        queryClient.invalidateQueries(getCompanyWiseQuery)
        queryClient.invalidateQueries(getAllTransactionQuery)
        if (values.length !== 0) {
          Toast('Tags Created/Updated Successfully!', ToastType.success)
          props.setShow(false)
        } else {
          Toast('All Tags Removed Successfully!', ToastType.success)
          props.setShow(false)
        }
      },
      onError: (error: any) => {
        Toast('Error updating tags', ToastType.error)
      },
    },
    {}
  )

  useEffect(() => {
    setValues((values: any) => {
      return values?.filter((element: any) => element?.value !== removeBadge)
    })
  }, [removeBadge])

  function addTagsToCompany() {
    const tags: string[] = []

    values.map((element: any) => {
      tags.push(element.value)
    })
    mutateAddTagsToCompany.mutate({
      input: {
        companyType: props.companyType,
        hissaCompanyId: props.hissaCompanyId,
        companyName: props.companyName,
        tags: tags,
        currency: props.currency,
        currentSharePrice: props.currentSharePrice,
        jurisdiction: props.jurisdiction,
      },
    })
  }

  return (
    <Modal
      id='kt_header_search_modal'
      aria-hidden='true'
      tabIndex={-1}
      dialogClassName='modal-dialog modal-dialog-centered h-auto mw-800px '
      show={props.showModal}
      centered
      animation={true}
      backdrop={true}
    >
      <Modal.Header className='p-9 pb-2'>
        <Modal.Title className='fs-1 text-gray-heading'>
          <div>Manage tags</div>
          <div className='fs-6'>
            Add tags to <b>{props.companyName}</b>
          </div>
        </Modal.Title>

        <button
          className='btn btn-sm btn-icon btn-active-light-primary '
          type='button'
          data-bs-toggle='tooltip'
          title='Close'
          onClick={() => {
            props.setShow(false)
          }}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </button>
      </Modal.Header>
      <Modal.Body className='p-9'>
        <div className='col fv-md-row d-md-flex align-items-baseline'>
          <div>
            <label className='d-flex align-items-center fs-5 fw-medium mb-4'>
              Select/Create Tags
            </label>
          </div>
          <div className='col-12 col-md-8 px-9'>
            {customTag === false ? (
              <Select
                className=''
                options={badgeList}
                placeholder={'--Select--'}
                value={values}
                isMulti={true}
                onChange={(e: any) => handleChange(e)}
                styles={selectCustomStyles}
              />
            ) : (
              <div className='d-flex'>
                <div className='me-4'>
                  <input
                    className='form-control form-control-solid me-2'
                    placeholder='Enter Tag Name'
                    onChange={handleChangeValue}
                  />
                </div>
                <button
                  className='btn btn-sm btn-icon btn-active-light-primary mb-9'
                  type='submit'
                  disabled={disable}
                  onClick={(e) => {
                    setValues((values: any) => [...values, { value: inputText, label: inputText }])
                    setCustomTag(false)
                  }}
                >
                  <KTSVG
                    className='svg-icon-1 text-primary'
                    path='/media/icons/duotune/arrows/arr012.svg'
                  />
                </button>
                <button
                  className='btn btn-sm btn-icon btn-active-light-primary mb-9'
                  onClick={() => {
                    setCustomTag(false)
                    setErrorMessage('')
                  }}
                >
                  <KTSVG
                    className='svg-icon-1 text-primary'
                    path='/media/icons/duotune/arrows/arr061.svg'
                  />
                </button>
              </div>
            )}
            <div className='text-danger mt-2'>
              {isEqual && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{errorMessage}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='p-9 border-0'>
        <div className='row justify-content-end'>
          <button
            type='submit'
            onClick={() => {
              addTagsToCompany()
            }}
            className='btn btn-lg btn-primary w-100 mt-3'
          >
            {!mutateAddTagsToCompany.isLoading && 'Save'}
            {mutateAddTagsToCompany.isLoading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Saving...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
